// this is aliased in webpack config based on server/client build
// import { createAPI } from 'create-api'

import request from '../util/request'
import trackerRequest from '../util/trackerRequest'
import axios from 'axios'

const logRequests = !!process.env.DEBUG_API

export async function fetchUser (handle) {
  const url = "/users?" + "handle=" + handle
  logRequests && console.log(`api ${url}...`)

  try {
    var response = await request({
        method: "get",
        url: url
    })

    
    return response
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}

export async function fetchPollGames(code) {
  const url = "/poll-game/answers?code=" + code
  logRequests && console.log(`api ${url}...`)

  try {
    var response = await request({
        method: "get",
        url: url
    })
    return response
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}

export async function sendMsg(sessionId, recipientId, msg) {
  // const url = "/api/conversations"
  const url = process.env.NODE_ENV === 'production' ? "https://ims.lmk.chat/api/conversations" : "https://im.dev.lmk.chat/api/conversations"
  logRequests && console.log(`api ${url}...`)

  try {
    var response = await request({
      method: "post",
      url: url,
      headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify({
        "recipientId": recipientId,
        "webSessionId": sessionId,
        "origin":"web",
        "message": {
          "content": msg,
          "contentType": "text"
        }
      })
    })

    return response
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}

export async function fetchQuestion(qid, handle) {
  let url = "/questions"
  if(qid) {
    url += `/${qid}`
  } else if(handle) {
    url += `?handle=${handle}`
  }
  logRequests && console.log(`api ${url}...`)

  try {
    var response = await request({
        method: "get",
        url: url
    })
    return response
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}

export async function fetchQuiz(qid, handle) {
  let url = '/quizzes'
  if(qid) {
    url += `/${qid}`
  } else if(handle) {
    url += `?handle=${handle}`
  }
  logRequests && console.log(`api ${url}...`)

  try {
    var response = await request({
        method: "get",
        url: url
    })
    return response
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}

export async function fetchRoom(rid) {
  let url = "/mario/room-invites"
  if(rid) {
    url += `/${rid}`
  }
  logRequests && console.log(`api ${url}...`)

  try {
    var response = await request({
        method: "get",
        url
    })

    return response
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}

export async function fetchEvent(rid) {
  let url = "/mario/event-invites"
  if(rid) {
    url += `/${rid}`
  }
  logRequests && console.log(`api ${url}...`)

  try {
    var response = await request({
        method: "get",
        url
    })

    return response
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}


export async function fetchSchool(rid) {
  let url = "/school-invites"
  if(rid) {
    url += `/${rid}`
  }
  logRequests && console.log(`api ${url}...`)

  try {
    var response = await request({
        method: "get",
        url
    })

    return response
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}

export async function sendAnswer(sessionId, qid, msg) {
  const url = "/questions/" + qid + "/answer"
  logRequests && console.log(`api ${url}...`)

  try {
    var response = await request({
      method: "post",
      url: url,
        headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify({
        "message": msg,
        "webSessionId": sessionId
      })
    })
    return response
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}

export async function sendAnswerOption(sessionId, qid, optionId) {
  const url = "/questions/" + qid + "/answer-option"
  logRequests && console.log(`api ${url}...`)
  try {
    var response = await request({
      method: "post",
      url: url,
        headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify({
        "optionId": optionId,
        "webSessionId": sessionId
      })
    })
    return response
  } catch (error) {
    console.log('error: ', error)
    throw error
  }
}

export async function sendAnswerCustomOption(sessionId, qid, choices) {
  const url = "/questions/" + qid + "/answer-option/custom"
  logRequests && console.log(`api ${url}...`)
  try {
    var response = await request({
      method: "post",
      url: url,
        headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify({
        "options": choices,
        "webSessionId": sessionId
      })
    })
    return response
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}

export async function sendAnswerCustom(sessionId, qid, subType, customAnswers) {
  const url = "/questions/" + qid + "/answer/custom"
  const paramName = `subType${subType}`
  logRequests && console.log(`api ${url}...`)
  try {
    var response = await request({
      method: "post",
      url: url,
        headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify({
        subType,
        "webSessionId": sessionId,
        [paramName]: customAnswers,
      })
    })
    return true
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}

export async function submitQuiz(sessionId, quizResponse) {
  const url = "/quiz/response"
  logRequests && console.log(`api ${url}...`)
  const { playerName = '', quiz = {}} = quizResponse
  try {
    var response = await request({
      method: "post",
      url: url,
        headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify({
        "webSessionId": sessionId,
        playerName,
        quiz,
      })
    })
    return response
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}

export async function uploadFile(file) {
  const baseUrl = process.env.NODE_ENV === 'production' ? "https://api.lmk.chat/" : "https://api.dev.lmk.chat/"
  const url = "files/image"
  logRequests && console.log(`api ${url}...`)
  try {
    const res = await axios.post(baseUrl + url, file)
    return res
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}

export async function fetchConversations(id) {
  let url = "/conversations"
  url += `/${id}`

  logRequests && console.log(`api ${url}...`)

  try {
    var response = await request({
        method: "get",
        url: url
    })
    return response
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}

export async function fetchCommunities(id) {
  let url = "/communities"
  url += `/${id}`

  logRequests && console.log(`api ${url}...`)

  try {
    var response = await request({
        method: "get",
        url: url
    })
    return response
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}

export async function fetchCommunitiesPosts(cid, pid) {
  let url = "/communities"
  url += `/${cid}/posts/${pid}` 

  logRequests && console.log(`api ${url}...`)

  try {
    var response = await request({
        method: "get",
        url: url
    })
    return response
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}

export async function fetchPost(pid) {
  let url = `/sydney/posts/${pid}` 

  logRequests && console.log(`api ${url}...`)

  try {
    var response = await request({
        method: "get",
        url: url
    })
    return response
  } catch (error) {
    console.log('error: ', error)
    return false
  }
}

export async function sendTracking(params) {
  const url = "/app/activities"
  logRequests && console.log(`api ${url}...`)
  try {
    const {
      event, 
      eventTime = new Date(), 
      timeszoneOffset = 0, 
      device = 
        {
          deviceId: 'web', 
          platform: 'web'
        },
        extraParams = {}, 
        appVersion = 'web',
        userId
      } = params
    var response = await trackerRequest({
      method: "post",
      url: url,
        headers: {
        'content-type': 'application/json'
      },
      data: JSON.stringify({
        event,
        userId,
        eventTime,
        timeszoneOffset,
        device, 
        extraParams,
        appVersion
      })
    })
    return response
  } catch (error) {
    console.log('error: ', error)
    throw error
  }
}
export function copyTextToClipboard(text) {
  var textArea = document.createElement("textarea");

  textArea.style.position = 'fixed';
  textArea.style.top = 0;
  textArea.style.left = 0;

  // Ensure it has a small width and height. Setting to 1px / 1em
  // doesn't work as this gives a negative w/h on some browsers.
  textArea.style.width = '2em';
  textArea.style.height = '2em';

  // We don't need padding, reducing the size if it does flash render.
  textArea.style.padding = 0;

  // Clean up any borders.
  textArea.style.border = 'none';
  textArea.style.outline = 'none';
  textArea.style.boxShadow = 'none';

  // Avoid flash of the white box if rendered for any reason.
  textArea.style.background = 'transparent';


  textArea.value = text;

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    console.log('Copying text command was ' + msg, text);
  } catch (err) {
    console.log('Oops, unable to copy');
  }

  document.body.removeChild(textArea);
}


// WEBPACK FOOTER //
// src/api/index.js